import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import { createVuetify } from "vuetify";

const darkTheme = {
  dark: true,
  colors: {
    background: "#0c0c0c",
    surface: "#141414",
    primary: "#04213b",
    secondary: "#999999",
    accent: "#04213b",
    error: "#ff0055",
    info: "#999999",
    success: "#ff0055",
    warning: "#ff0055",
  },
};

export default createVuetify({
  theme: {
    defaultTheme: "darkTheme",
    themes: { darkTheme },
  },
});
